import { SimpleGrid } from '@chakra-ui/react';
import ProviderCardSkeleton from './ProviderCardSkeleton';

interface ProvidersGridSkeletonProps {
  countPerRow?: number; // number of cards per row (1-4)
  total?: number; // total number of skeletons to show
}

const ProvidersGridSkeleton = ({ countPerRow = 4, total = 8 }: ProvidersGridSkeletonProps) => {
  // clamp between 1 and 4
  const columns = Math.min(Math.max(countPerRow, 1), 4);

  return (
    <SimpleGrid columns={columns} spacing="20px" justifyItems="center" w="full">
      {Array.from({ length: total }).map((_, i) => (
        <ProviderCardSkeleton key={i} />
      ))}
    </SimpleGrid>
  );
};

export default ProvidersGridSkeleton;
